import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { M2StaticDatumsEdit } from "./edit";
import { M2StaticDataNew } from "./new";
import { M2StaticDatumsTable } from "./table";
export default function M2StaticData() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<M2StaticDatumsEdit />} />
      <Route index element={<M2StaticDatumsTable />} />
      <Route path="/new" element={<M2StaticDataNew />} />
    </Routes>
  );
}
